import createTypography from '@mui/material/styles/createTypography';
import palette from './palette';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    huge: React.CSSProperties;
    xxl: React.CSSProperties;
    xl: React.CSSProperties;
    large: React.CSSProperties;
    medium: React.CSSProperties;
    small: React.CSSProperties;
    xs: React.CSSProperties;
    micro: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    huge?: React.CSSProperties;
    xxl?: React.CSSProperties;
    xl?: React.CSSProperties;
    large?: React.CSSProperties;
    medium?: React.CSSProperties;
    small?: React.CSSProperties;
    xs?: React.CSSProperties;
    micro?: React.CSSProperties;
  }
}

declare module '@mui/material/styles/createTypography' {
  interface TypographyOptions {
    fontWeightSemibold?: number;
    huge?: React.CSSProperties;
    xxl?: React.CSSProperties;
    xl?: React.CSSProperties;
    large?: React.CSSProperties;
    medium?: React.CSSProperties;
    small?: React.CSSProperties;
    xs?: React.CSSProperties;
    micro?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    huge: true;
    xxl: true;
    xl: true;
    large: true;
    medium: true;
    small: true;
    xs: true;
    micro: true;
  }
}

const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

const typography = createTypography(palette, {
  fontFamily: 'Poppins, sans-serif',
  fontWeightRegular: fontWeights.regular,
  fontWeightMedium: fontWeights.medium,
  fontWeightSemibold: fontWeights.semibold,
  fontWeightBold: fontWeights.bold,

  huge: {
    fontSize: 32,
    letterSpacing: -1.5,
    fontWeight: fontWeights.bold,
    lineHeight: '36px',
  },
  xxl: {
    fontSize: 24,
    letterSpacing: -1,
    fontWeight: fontWeights.bold,
    lineHeight: '28px',
  },
  xl: {
    fontSize: 20,
    letterSpacing: -0.5,
    fontWeight: fontWeights.regular, // weight reset for browser default h3
  },
  large: {
    fontSize: 16,
  },
  medium: {
    fontSize: 14,
    lineHeight: '18px',
  },
  small: {
    fontSize: 12,
    lineHeight: '16px',
  },
  xs: {
    fontSize: 11,
    lineHeight: '16px',
  },
  micro: {
    fontSize: 10,
  },
});

export default typography;
